/**
 * Whether this deployment can reach Heidi's people: the support desk, and the
 * product team that reads feedback and ratings.
 *
 * An air-gapped appliance can reach neither. Its users are supported by the
 * hospital's own IT team, and a rating submitted there is read by no one. So
 * copy that sends the user to Heidi support names their IT team instead, and
 * surfaces that solicit feedback do not render.
 *
 * INTERIM: the real question is the appliance's egress posture, which the
 * frontend is not allowed to read — it is meant to arrive as a capability the
 * backend reports (onprem-guardrails F9), and no route reports one yet. Until
 * one does, every on-prem build takes the air-gapped answer, including an
 * allowlisted appliance that could in principle reach Heidi. When the
 * capability lands, only the on-prem arm of these two values changes; a cloud
 * build's answer stays the literal `true` it folds to today.
 *
 * Safety and clinical-incident reporting is not product feedback and is not
 * governed by `isProductFeedbackAvailable`.
 *
 * Plain consts for the reason `buildProfile.ts` gives: the bundler folds the
 * branch and drops the unreachable arm.
 */
import { isOnPrem } from '@/utils/buildProfile';

/** ON-PREM-GATE: Heidi's support desk (Intercom, support email, help desk). */
export const isHeidiSupportReachable: boolean = !isOnPrem;

/** ON-PREM-GATE: thumbs, star ratings, CSAT prompts and feedback links. */
export const isProductFeedbackAvailable: boolean = !isOnPrem;
